class BusinessUnit {
  constructor(id, name, ws) {
    this.id = id;
    this.name = name;
    this.ws = ws;
  }

  static fromJson({ unNegocioId, nombre, ws }) {
    return new BusinessUnit(unNegocioId, nombre, ws);
  }
}

export default BusinessUnit;
